(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3180],{

/***/ 74011:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/GIMS",
      function () {
        return __webpack_require__(38355);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Gims; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _interactive_report__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62787);
/* eslint-disable camelcase */ /* eslint-disable no-unused-vars */ // eslint-disable-next-line import/no-unresolved


function Gims() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("interactive_report", {});
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3517,4540,3835,1816,5426,877,517,2390,3408,9073,8346,594,4215,5675,1199,112,7929,7841,5739,8956,2787,9774,2888,179], function() { return __webpack_exec__(74011); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);